import auditType from '@/constants/register/auditType'
import qs from 'qs'
import { instance, instanceExternal } from './axios'

const baseUrl = '/web-api/api/'
const cpUrl = '/web-api/cp/api/'

const loginUrl = `${baseUrl}login/`
const fileUrl = `${baseUrl}file/`
const smsUrl = `${baseUrl}request-sms-code`
const smsVerifyUrl = `${baseUrl}verify-sms-code`
const userUrl = `${cpUrl}user/`
const homeUrl = `${cpUrl}home/`
const withdrawalUrl = `${cpUrl}withdrawal/`
const paymentSelectionUrl = `${baseUrl}payment/`
const transferUrl = `${cpUrl}transfer/`
const depositUrl = `${cpUrl}deposit/`
const accountUrl = `${cpUrl}account/`
const cardRegisterUrl = `${cpUrl}card-register/`
const passwordUrl = `${cpUrl}password/`
const profileUrl = `${cpUrl}profile/`
const fundsUrl = `${cpUrl}funds/`
const transactionHistoryUrl = `${cpUrl}transactionHistory/`
const questionnaireUrl = `${cpUrl}questionnaire/`
const depositlResultPath = 'result'
const checkResetPasswordAuthorization = `${profileUrl}check_reset_password_authorization`
const submitResetProfilePassword = `${profileUrl}submit_reset_profile_password`
const submitResetChangeIpWarn = `${profileUrl}reset_change_ip_warn`
const submitResetMt4AccountPassword = `${cpUrl}password/submit_reset_mt4_password`
const submitResetForgetPassword = `${cpUrl}password/reset-mobile-password`
const identifyProofUrl = `${cpUrl}identityProof/`
const userProfileUrl = `${baseUrl}userProfile/`
const tcmktUrl = `${baseUrl}tcmkt/`
const demoUrl = `${cpUrl}demo/`
const locationTrace = `https://secure.vantagemarkets.com/cdn-cgi/trace`
const googleTranslateBasic = `https://translation.googleapis.com/language/translate/v2?key=AIzaSyCKuPDmPYUTdOFUitGsQzH3rLgs58B4_I0`
const notificationUrl = `${baseUrl}notification/`
const bannerUrl = `${baseUrl}banner/`
const sliderCheckerUrl = `${baseUrl}sliderChecker/`
const systemUrl = `${baseUrl}system/`
const tradingTips = `${baseUrl}tradingTips/`
const socialTradingUrl = `${cpUrl}socialTrading/`
const cardAuditUrl = `${cpUrl}card-audit/`
const mfaUrl = `${baseUrl}mfa/`
const abTestingUrl = `${baseUrl}ab_testing/`

export const personalDetailUrl = `${baseUrl}personalDetail/`
export const verificationUrl = `${baseUrl}verification/`
export const verificationV2Url = `${baseUrl}verificationV2/`
export const questionUrl = `${baseUrl}question/`
export const cpsDepositUrl = `${depositUrl}`
export const cpsUrl = `${depositUrl}cps/`
export const cpsWithdrawalUrl = `${withdrawalUrl}`

const securityManageUrl = `${cpUrl}multiFactorAuth/`
const authUrl = `${cpUrl}two-factor/`

export const propTradingUrl = `${baseUrl}propTrading/`
export const depositUrlV2 = `${depositUrl}v2/`

/** login */
// export const apiTo_login = data => instance.post(`${loginUrl}to_login`, qs.stringify(data))
// export const apiTo_logout = data =>
//   instance.get(`${loginUrl}to_logout`, { headers: { Pragma: 'no-cache' }, params: data })
// export const apiTo_login_by_token = headers => instance.post(`${loginUrl}to_login_by_token`, '', headers)
// export const apiTo_login_register = data => instance.post(`${loginUrl}to_login_register`, qs.stringify(data))
// export const apiTo_sms_code_login = data => instance.post(`${loginUrl}login-after-sms-code-check`, qs.stringify(data))

/**
 * new login
 */
// 登录
export const apiTo_login = (data) =>
  instance.post(`/hgw/auth-api/login/customer/pc/to_login`, data)
// // 手机号发送验证码？
// // 登出
export const apiTo_logout = (data) =>
  instance.post(`/hgw/auth-api/login/customer/logout`, data)
// // 获取用户信息
export const apiGetUserInfo = (data) =>
  instance.post(`/hgw/user-api/outer/login/getUserInfo`, data)
/**
 * new login end
 */

/** user **/
export const apiGetUsername = () => instance.get(`${userUrl}getUsername`)

/** home */
export const apiQueryMetaTraderAccountDetails = data =>
  instance.post(`${homeUrl}query-metaTrader-account-details`, data)
export const apiQueryMetaTraderAccounts = data => instance.post(`${homeUrl}query-metaTrader-account-overview`, data)
export const apiQueryLeverageStatuses = data => instance.post(`${homeUrl}query-leverage-statuses`, data)
export const apiQueryAvailableLeverages = data => instance.post(`${homeUrl}query-available-leverages`, data)
export const apiUpdate_leverage = data => instance.post(`${homeUrl}update-leverage`, data, { timeout: 30000 })
export const apiUpdate_leverage_demo = data => instance.post(`${homeUrl}update-leverage-demo`, data, { timeout: 30000 })
export const apiReactivate_Account = data => instance.post(`${homeUrl}reactivate-account`, data)
export const apiHomeGet_demo_accs = data => instance.get(`${homeUrl}get-demo-accs`, data)
export const apiupdate_balance_demo = data => instance.post(`${homeUrl}update-balance-demo`, data)
export const apiRestAccountBalance = data => instance.post(`${homeUrl}restAccount/${data}`)
export const apiGetFundStatus = () => instance.get(`${homeUrl}check-client-fund-status`)
export const apiAccount_change_group = data => instance.post(`${homeUrl}account-change-group`, data)

/** userProfile*/
export const apiSetlanguage = data => instance.post(`${userProfileUrl}setlanguage`, qs.stringify(data))

/** withdrawal */
export const apiIsCreditCardDeposit_cp = data => instance.post(`${withdrawalUrl}isCreditCardDeposit_cp`, data)
export const apiGetWithdrawalData_cp = () => instance.post(`${withdrawalUrl}getWithdrawalData_cp`)
export const apiGetNonCreditCardWithdrawTypeCP = data =>
  instance.post(`${withdrawalUrl}getNonCreditCardWithdrawTypeCP`, data)
export const apiApplyWithdrawal_cp = (data, token) =>
  instance.post(`${withdrawalUrl}applyWithdrawal_cp`, data, { headers: { token: token } })
export const apiUnionpay_banklist = () => instance.get(`${cardRegisterUrl}getBankName`)
export const apiRegisterUnionPayCard_cp = data => instance.post(`${withdrawalUrl}registerCard`, data)
export const apiGetWithdrawDeductCredit = (data) =>
  instance.post(`${withdrawalUrl}getDeductCredit`, data)
export const apiCardInformation = data => instance.get(`${withdrawalUrl}queryUnionpayCard`, { param: data })
export const apiWithdrawalBlacklist = () => instance.get(`${withdrawalUrl}queryBlacklist`)
export const apiCreditCardBalances = data => instance.get(`${withdrawalUrl}creditCard/balances/${data.currency}`, data)
export const apiGetLBTWithdrawalData_cp = data =>
  instance.get(`${withdrawalUrl}getLBTWithdrawalData_cp`, { params: data })
export const apiApplyWithdrawal_cp_batch = (data, token) =>
  instance.post(`${withdrawalUrl}applyWithdrawal_cp_batch`, data, { headers: { token: token } })
export const apiWithdrawalQueryRateUSDByTargetCurrency = targetCurrency =>
  instance.get(`${withdrawalUrl}queryRateUSDByTargetCurrency/${targetCurrency}`)
export const apiGetWithdrawalBankCode = () => instance.get(`${withdrawalUrl}queryBankCode`)
export const apiGetWithdrawalBankBranchCode = bankCode => instance.get(`${withdrawalUrl}queryAllByBankCode/${bankCode}`)
export const apiCancelWithdraw = ({ withdrawalId, paymentWithdrawType }) =>
  instance.post(
    `${withdrawalUrl}cancelWithdrawalOrder?withdrawalId=${withdrawalId}&paymentWithdrawType=${paymentWithdrawType}`
  )
export const apiCheckClientTradeLot = ({ userId, accountId }) =>
  instance.get(`${withdrawalUrl}checkClientTradeLot?userId=${userId}&accountId=${accountId}`)
export const apiWithdrawExchangeRate = data =>
  instance.get(`${withdrawalUrl}exchangeRate?fromCurrency=${data.fromCurrency}&toCurrency=${data.toCurrency}`)

export const apiSendEmailVerificationCode = data => instance.post(`${mfaUrl}sendEmailVerificationCode`, data)

/** Security */
export const apiGetSecurityInfo = () => instance.get(`${securityManageUrl}info`)
export const apiGetHint = () => instance.get(`${securityManageUrl}hintInfo`)
export const apiGetMultiFactorAuth = functionCode =>
  instance.get(`${securityManageUrl}${functionCode}/getMultiAuthMethod`)
export const apiAuthStatus = () => instance.get(`${authUrl}status`)
export const apiPreValidateTotp = data => instance.post(`${securityManageUrl}totp/preValidate`, data)
export const apiPreValidateEmail = data => instance.post(`${securityManageUrl}email/preValidate`, data)
export const apiChangeEmail = data => instance.post(`${securityManageUrl}changeEmail`, data)
export const apiChangeSwitch = data => instance.post(`${securityManageUrl}switch`, data)
export const apiVerifyEmail = () => instance.post(`${securityManageUrl}verifyEmail`)
export const apiAddTwoFactor = data => instance.post(`${authUrl}enable`, data)
export const apiModifyTwoFactor = data => instance.post(`${securityManageUrl}totp/change/${data}`)
export const apiValidateEnv = () => instance.get(`${securityManageUrl}validateEnv`)

/** Payment */
export const apiPaymentSelection = data => instance.post(`${paymentSelectionUrl}info/getPaymentInfoList/`, data)
export const apiPaymentGetInfo = data => instance.post(`${paymentSelectionUrl}info/getInfo/`, data)
export const apiDeleteBankAccountInfo = id =>
  instance.post(`${paymentSelectionUrl}info/deleteBankAccountInfo?bankAccountInfoId=${id}`)

/** transfer */
export const apiGetTransferData_cp = () => instance.post(`${transferUrl}getTransferData_cp`)
export const apiApplyTransfer_cp = (data, token) =>
  instance.post(`${transferUrl}applyTransfer_cp`, qs.stringify(data), { headers: { token: token } })
export const apiTransferPermission = data => instance.post(`${transferUrl}transferPermission`, qs.stringify(data))
export const apiGetTransferDeductCredit = (data) =>
  instance.post(`${transferUrl}getDeductCredit`, data)
export const apiTransferBlacklist = () => instance.get(`${transferUrl}queryBlacklist`)
//Get transferable currency based on selected account's currency
export const apiGetTransferableCurrency = data => instance.get(`${transferUrl}currencyList?formCurrency=${data}`)
export const apiGetTransferToRate = data =>
  instance.get(`${transferUrl}currencyRate?formCurrency=${data.formCurrency}&&toCurrency=${data.toCurrency}`)

/** file */
export const apiDelete_file = data => instance.post(`${fileUrl}delete`, data)

/** account */
export const apiGetMetaTraderAccounts = () => instance.get(`${accountUrl}getMetaTraderAccounts`)
export const apiApplyAdditionalAccount = data =>
  instance.post(`${accountUrl}applyAdditionalAccount`, qs.stringify(data))
export const apiCheckEquity = data =>
  instance.get(`${accountUrl}check_equity?mt4Account=${data.mt4Account}&&amount=${data.amount}`)
export const apiCreateDemoAccount = data => instance.post(`${accountUrl}createDemoAccount`, data)
export const apiIsHideAccountType = () => instance.get(`${accountUrl}isHideAccountType`)
export const apiGetAdditionalAccountType = () => instance.get(`${accountUrl}getAdditionalAccountType`)
export const apiGetAccountType = () => instance.get(`${accountUrl}getAccountType`)
export const apiGetFirstAccountAuditStatus = () => instance.get(`${accountUrl}getFirstAccountAuditStatus`)

/** deposit */
export const apiDepositBlacklist = () => instance.get(`${depositUrl}queryBlacklist`)
export const apiRestrictedDeposit = () => instance.post(`${depositUrl}getRestrictedDepositData`)
export const apiCc_payment = data => instance.post(`${depositUrl}cc_payment`, data)
export const apiCc_payment_365 = data => instance.post(`${depositUrl}cc_payment_365`, data)
export const apiCc_payment_solid = data => instance.post(`${depositUrl}cc_solidpay`, data)
export const apiCc_payment_solidSA = data => instance.post(`${depositUrl}cc_payment_solid_sa`, data)
export const apiCc_solid_order = (data, token) =>
  instance.post(`${depositUrl}solid-payment/order`, data, { headers: { token: token } })
export const apiCc_payment_worldcard = data => instance.post(`${depositUrl}cc_payment_worldcard`, data)
export const apiCc_payment_apg = data => instance.post(`${depositUrl}cc_payment_apg`, data)
export const apiPowercash = data => instance.post(`${depositUrl}powercash`, data)
export const apiCc_checkout_payment = data => instance.post(`${depositUrl}cc_checkout_payment`, data)
export const apiFetch_card = data => instance.post(`${depositUrl}fetch_card`, data)
export const apiUpload_card = data => instance.post(`${depositUrl}upload_cc_img`, data)
export const apiQuery_mt_accounts = data => instance.post(`${depositUrl}query_mt_accounts`, qs.stringify(data))
export const apiQuery_mt_accounts_all = data => instance.post(`${depositUrl}query_mt_accounts/all`, qs.stringify(data))
export const apiQueryRate_USD_VND = () => instance.post(`${depositUrl}queryRate_USD_VND`)
export const apiRequire_token = () => instance.post(`${depositUrl}require_token`)
export const apiAnti_Reuse = () => instance.get(`${baseUrl}token/anti-reuse`)
export const apiQueryRate = () => instance.post(`${depositUrl}queryRate`)
export const apiQuery_paymentChannel = () => instance.post(`${depositUrl}query_paymentChannel`)
export const apiQueryPagsmileExchangeRate = () => instance.get(`${depositUrl}pagsmile/queryExchangeRate`)
export const apiQueryRate_USD_NGN = () => instance.post(`${depositUrl}queryRate_USD_NGN`)
export const apiQueryRate_USD_MYR = () => instance.post(`${depositUrl}queryRate_USD_MYR`)
export const apiQueryRate_USD_IDR = () => instance.post(`${depositUrl}queryRate_USD_IDR`)
export const apiQueryRate_USD_LAK = () => instance.post(`${depositUrl}queryRate_USD_LAK`)
export const apiQueryRate_USD_INR = () => instance.post(`${depositUrl}queryRate_USD_INR`)
export const apiQueryRate_USD_BRL = () => instance.post(`${depositUrl}queryRate_USD_BRL`)
export const apiQueryRate_USD_PHP = () => instance.post(`${depositUrl}queryRate_USD_PHP`)
export const apiQueryRate_USD_JPY = () => instance.post(`${depositUrl}queryRate_USD_JPY`)
export const apiQueryRateUSDByTargetCurrency = data =>
  instance.post(`${depositUrl}queryRateUSDByTargetCurrency`, qs.stringify(data))
export const apiQuery_malaysia_paymentChannel = () => instance.post(`${depositUrl}query_malaysia_paymentChannel`)
export const apiQueryUserPayRigths = () => instance.post(`${depositUrl}queryUserPayRigths`)
export const apiGet_rate = data => instance.post(`${depositUrl}get_rate`, qs.stringify(data))
export const apiGet_holder_name = data => instance.post(`${depositUrl}get_holder_name`, qs.stringify(data))
export const apiGet_mobile_rate = data => instance.post(`${depositUrl}get_mobile_rate`, qs.stringify(data))
export const apiGet_rate_api = data => instance.post(`${depositUrl}payabl/queryRate`, qs.stringify(data))
export const apiExchangeRate = data =>
  instance.get(`${depositUrl}exchangeRate?fromCurrency=${data.fromCurrency}&toCurrency=${data.toCurrency}`)

export const apiBridge_payment = (data, token) =>
  instance.post(`${depositUrl}bridgepay`, data, { headers: { token: token } })
export const apiVietnam_bankwire_payment = (data, token) =>
  instance.post(`${depositUrl}vietnam_bankwire_payment`, data, { headers: { token: token } })
export const apiEeziePay_payment = (data, token) =>
  instance.post(`${depositUrl}eeziepay`, data, { headers: { token: token } })
export const apiXpay_payment = (data, token) =>
  instance.post(`${depositUrl}xpay_payment`, data, { headers: { token: token } })
export const apiUnionpay_transfer = (data, token) =>
  instance.post(`${depositUrl}unionpay_transfer`, data, { headers: { token: token } })
export const apiUnionpay = (data, token) => instance.post(`${depositUrl}unionpay`, data, { headers: { token: token } })
export const apiZotapay_payment = (data, token) =>
  instance.post(`${depositUrl}zotapay_payment`, data, { headers: { token: token } })
export const apiTransact365_payment = (data, token) =>
  instance.post(`${depositUrl}transact365-th`, data, { headers: { token: token } })
export const apiPaytoday_payment = (data, token) =>
  instance.post(`${depositUrl}paytoday_payment`, data, { headers: { token: token } })
export const apiThaipayvip_payment = (data, token) =>
  instance.post(`${depositUrl}thaipayvip_payment`, data, { headers: { token: token } })
export const apiSkrill_payment = (data, token) =>
  instance.post(`${depositUrl}skrill/payment`, data, { headers: { token: token } })
export const apiPoli_payment = (data, token) =>
  instance.post(`${depositUrl}poli_payment`, data, { headers: { token: token } })
export const apiNigeria_bankwire_payment = (data, token) =>
  instance.post(`${depositUrl}nigeria_bankwire_payment`, data, { headers: { token: token } })
export const apiNeteller_payment = (data, token) =>
  instance.post(`${depositUrl}paysafe_neteller`, data, { headers: { token: token } })
export const apiPaypal_payment = (data, token) =>
  instance.post(`${depositUrl}paypal_payment`, data, { headers: { token: token } })
export const apiCardpay_payment = (data, token) =>
  instance.post(`${depositUrl}cardpay_payment`, data, { headers: { token: token } })
export const apiMobile_payment = (data, token) =>
  instance.post(`${depositUrl}mobile_payment`, data, { headers: { token: token } })
export const apiMalaysia_bankwire_payment = (data, token) =>
  instance.post(`${depositUrl}malaysia_bankwire_payment`, data, { headers: { token: token } })
export const apiInternational_bank_payment = (data, token) =>
  instance.post(`${depositUrl}international_bank_payment`, data, { headers: { token: token } })
export const apiFasapay_payment = (data, token) =>
  instance.post(`${depositUrl}fasapay_payment`, data, { headers: { token: token } })
export const apiMijipay_payment = (data, token) =>
  instance.post(`${depositUrl}mijipay_payment`, data, { headers: { token: token } })
export const apiBroker_to_broker_payment = (data, token) =>
  instance.post(`${depositUrl}broker_to_broker_payment`, data, { headers: { token: token } })
export const apiBpay_payment = (data, token) =>
  instance.post(`${depositUrl}bpay_payment`, data, { headers: { token: token } })
export const apiAustralian_bank_payment = (data, token) =>
  instance.post(`${depositUrl}australian_bank_payment`, data, { headers: { token: token } })
export const apiCrypto_payment = (data, token) =>
  instance.post(`${depositUrl}crypto_payment`, data, { headers: { token: token } })
export const apiCryptousdt_payment = (data, token) =>
  instance.post(`${depositUrl}cryptousdt_payment`, data, { headers: { token: token } })
export const apiCryptouBtcCps_payment = (data, token) =>
  instance.post(`${depositUrl}unionpay_transfer_btc`, data, { headers: { token: token } })
export const apiCryptouOmniCps_payment = (data, token) =>
  instance.post(`${depositUrl}unionpay_transfer_omni`, data, { headers: { token: token } })
export const apiCryptousdtcps_payment = (data, token) =>
  instance.post(`${depositUrl}unionpay_transfer_usdt`, data, { headers: { token: token } })
export const apiCryptoTrcCps_payment = (data, token) =>
  instance.post(`${depositUrl}unionpay_transfer_trc`, data, { headers: { token: token } })
export const apiPaywize_payment = (data, token) =>
  instance.post(`${depositUrl}paywize_payment`, data, { headers: { token: token } })
export const apiEverpay = (data, token) => instance.post(`${depositUrl}everpay`, data, { headers: { token: token } })
export const apiCpsDepositH5_payment = (data, token) =>
  instance.post(`${depositUrl}cpsDepositH5`, data, { headers: { token: token } })
export const apiDasshpeUPI_payment = (data, token) =>
  instance.post(`${depositUrl}dasshpe_upi_payment`, data, { headers: { token: token } })
export const apiDasshpeNB_payment = (data, token) =>
  instance.post(`${depositUrl}dasshpe_netBanking_payment`, data, { headers: { token: token } })
export const apiEeziepayUPI_payment = (data, token) =>
  instance.post(`${depositUrl}eeziepay_upi`, data, { headers: { token: token } })
export const apiPaymentAsia_payment = (data, token) =>
  instance.post(`${depositUrl}paymentasia_payment`, data, { headers: { token: token } })
export const apiEeziePay_banklist = data => instance.get(`${depositUrl}eeziepay/getBankList?context=eeziepay.inr`, data)
export const apiDasshpeNB_banklist = (data, token) =>
  instance.get(`${depositUrl}dasshpe/getBankList?context=dasshpe_netbanking`, data)
export const apiDasshpeWallet_payment = (data, token) =>
  instance.post(`${depositUrl}dasshpeWallet/payment`, data, { headers: { token: token } })
export const apiDasshpeWallet_banklist = (data, token) =>
  instance.get(`${depositUrl}dasshpeWallet/getBankList?context=dasshpe_wallet`, data)
export const apiDollarsmart_payment = (data, token) =>
  instance.post(`${depositUrl}dollarsmart`, data, { headers: { token: token } })
export const apiDollarsmart_confirmation = (data, token) =>
  instance.post(`${depositUrl}dollarsmart/update`, qs.stringify(data), { headers: { token: token } })
//QR入金页面提交，获取二维码接口
export const apiDollarSmartQR_payment = (data, token) =>
  instance.post(`${depositUrl}dollarsmartQR`, data, { headers: { token: token } })
//扫码完成接口
export const apiDollarSmartQRcode_confirmation = (data, token) =>
  instance.post(`${depositUrl}dollarsmartQR/update`, qs.stringify(data), { headers: { token: token } })
export const apiPagsmileBrazil_payment = (data, token) =>
  instance.post(`${depositUrl}brazil_payment`, data, { headers: { token: token } })
export const apiPagsmile_payment = (data, token) =>
  instance.post(`${depositUrl}pagsmile`, data, { headers: { token: token } })
export const apiPerfectMoney = (data, token) =>
  instance.post(`${depositUrl}perfectmoney`, data, { headers: { token: token } })
export const apiLocalDepositor_transfer = (data, token) =>
  instance.post(`${depositUrl}localdepositor`, data, { headers: { token: token } })
export const apiLocalDepositor_depositor = data => instance.get(`${depositUrl}localdepositor/depositors`, data)
export const apiIndiaP2PSubmitReceipt = (data, token) =>
  instance.post(`${depositUrl}submit-india-p2p`, data, { headers: { token: token } })
export const api2C2P_FPX_payment = (data, token) =>
  instance.post(`${depositUrl}2c2p/fpx`, data, { headers: { token: token } })
export const api2C2P_eWallet_payment = (data, token) =>
  instance.post(`${depositUrl}2c2p/e-wallet`, data, { headers: { token: token } })
export const apiJapanP2PMakeOrder = token =>
  instance.post(`${depositUrl}japanGetBankInfo`, { headers: { token: token } })
export const apiJapanP2PSubmitReceipt = (data, token) =>
  instance.post(`${depositUrl}japanP2PSubmitReceipt`, data, { headers: { token: token } })
export const apiNigeriaMakeOrder = token =>
  instance.post(`${depositUrl}nigeriaGetBankInfo`, { headers: { token: token } })
export const apiNigeriaP2P_payment = (data, token) =>
  instance.post(`${depositUrl}nigeria_p2p`, data, { headers: { token: token } })
export const apiBitwallet_payment = (data, token) =>
  instance.post(`${depositUrl}bitwallet`, data, { headers: { token: token } })
export const apiWalaopay_banklist = data =>
  instance.get(`${depositUrl}walaopay/get-bank-list?context=walaopay.vnd`, data)
export const apiWalaopay_payment = (data, token) =>
  instance.post(`${depositUrl}vietnam-walaopay`, data, { headers: { token: token } })
export const apiPaystack_payment = (data, token) =>
  instance.post(`${depositUrl}paystack`, data, { headers: { token: token } })
export const apiPhilipiness_bankwire_payment = (data, token) =>
  instance.post(`${depositUrl}philippines_bankwire_payment`, data, { headers: { token: token } })
export const apiIDeal_banxa_payment = (data, token) =>
  instance.post(`${depositUrl}ideal-banxa`, data, { headers: { token: token } })
export const apiTransact365_IDR_payment = (data, token) =>
  instance.post(`${depositUrl}transact365BankPay`, data, { headers: { token: token } })
export const apiTransact365_banklist = data => instance.get(`${depositUrl}indonesia/getBankList?context=18`, data)
export const apiJapan_Zotapay = (data, token) =>
  instance.post(`${depositUrl}japan_bankwire_payment`, data, { headers: { token: token } })
export const apiVietnamBankTransfer = (data, token) =>
  instance.post(`${depositUrl}vietnamP2PSubmitReceipt`, data, { headers: { token: token } })
export const apiIndo_Zotapay = (data, token) =>
  instance.post(`${depositUrl}indonesiaZotapay`, data, { headers: { token: token } })
export const apiInterac_banxa_payment = (data, token) =>
  instance.post(`${depositUrl}interac-banxa`, data, { headers: { token: token } })
export const apiInterac_gigadat_payment = (data, token) =>
  instance.post(`${depositUrl}interac-gigadat`, data, { headers: { token: token } })

// payabl netbanking
export const apiNetbanking = (data, token) =>
  instance.post(`${depositUrl}payabl/netbanking`, data, { headers: { token: token } })

/** cardRegister */
export const apiCredit_card = data => instance.post(`${cardRegisterUrl}credit_card`, data)
export const apiHistoryList = data => instance.post(`${cardRegisterUrl}history/list`, data)
export const apiGetCardDetials = data =>
  instance.get(`${cardRegisterUrl}get-card-info?cardId=${data.cardId}&&cardType=${data.cardType}`)
export const apiRemoveCard = data => instance.post(`${cardRegisterUrl}unionpay_card/update`, data)
export const apiUpdateCreditCard = data => instance.post(`${cardRegisterUrl}/credit_card/update`, data)

/**card audit */
export const cardAuditSubmit = data => instance.post(`${cardAuditUrl}submit`, data)

/** password */
export const apiUpdate_mt4_account_password = data => instance.post(`${passwordUrl}update_mt4_account_password`, data)
export const apiReq_reset_mt4_password = data => instance.post(`${passwordUrl}req_reset_mt4_password`, data)
export const apiCheck_new_password = data => instance.post(`${passwordUrl}check_new_password`, data)
export const apiCheck_current_password = data => instance.post(`${passwordUrl}check_current_password`, data)

/** profile */
export const apiInfo = () => instance.post(`${profileUrl}info`)
export const apiCheckPassword = data => instance.post(`${profileUrl}checkPassword`, qs.stringify(data))
export const apiEncryptPublicKey = (token = null) => instance.get(`${cpUrl}keyPair/pk?token=${token}`)
export const apiUpdatePassword = (data, publicKey) =>
  instance.post(`${profileUrl}updatePassword`, qs.stringify(data), { headers: { pk: publicKey } })
export const apiReq_reset_profile_password = data =>
  instance.post(`${profileUrl}req_reset_profile_password`, qs.stringify(data))
export const apiReq_reset_get_sms = data => instance.post(`${smsUrl}`, data)
export const apiReq_reset_profile_password_mobile = data => instance.post(`${smsVerifyUrl}`, data)
export const apiSubmitResetChangeIpWarn = data => instance.post(`${submitResetChangeIpWarn}`, qs.stringify(data))
export const apiForceUpdatePassword = data => instance.post(`${profileUrl}force_update_password`, data)
export const apiCheckMfaSwitchd = () => instance.get(`${profileUrl}checkMfaSwitch`)

/** funds */
export const apiTransferHistoryGet = data =>
  instance.get(`${fundsUrl}transfer-history/get`, {
    params: data,
  })

/** identityProof */
export const apiVerificationIdentityProofs = data => instance.post(`${identifyProofUrl}verification`, data)
export const apiCheckRecordExists = data => instance.post(`${identifyProofUrl}check_record_exists`, data)
export const apiGet_last_identifiy_proof = (documentTypeId, auditTypeId = auditType.general) =>
  instance.get(`${identifyProofUrl}get_last_identifiy_proof?documentType=${documentTypeId}&auditType=${auditTypeId}`)
export const apiAttach_new_document = data => instance.post(`${identifyProofUrl}attach_new_document`, data)
export const apiUpdate_user_id_address = data => instance.post(`${identifyProofUrl}updateUserIdAddress`, data)
export const apiDoId3 = data => instance.post(`${identifyProofUrl}doID3`, data)
export const apiVerificationV2 = data => instance.post(`${identifyProofUrl}verificationV2`, data)
/**
 *Thirdparty Deposit Result
 * @param {*} url
 * @param {*} data
 */
export const apiThirdPartyDepositResult = (paymentType, data) =>
  instance.post(`${depositUrl}` + paymentType + `/${depositlResultPath}`, data, {
    timeout: 30000,
  })

/** transactionHistory */
export const apiTransactionHistory = (url, data) => instance.post(`${transactionHistoryUrl}${url}`, qs.stringify(data))
export const apiDownloadAccountTransactionHistoryPDF = data =>
  instance.post(`${transactionHistoryUrl}/downloadAccountTransactionHistoryPDF`, data)
export const apiTransactionOrderHistory = (data) => {
  return instance.post(`${cpUrl}funds/trading-history/get`, data)
}
/** questionnaireUrl */
export const apiCheck = data => instance.post(`${questionnaireUrl}check`, data)

/**
 * reset password
 */
export const apiCheckResetPasswordAuthorization = data => instance.post(`${checkResetPasswordAuthorization}`, data)
export const apiSubmitResetProfilePassword = (data, publicKey) =>
  instance.post(`${submitResetProfilePassword}`, qs.stringify(data), { headers: { pk: publicKey } })
export const apiSubmitResetMt4AccountPassword = data => instance.post(`${submitResetMt4AccountPassword}`, data)
export const apiSubmitResetForgetPassword = data => instance.post(`${submitResetForgetPassword}`, data)

/** tcmktUrl */
export const apiTcmktCheckDeposit = data => instance.post(`${tradingTips}check/deposit`, data)
export const apiTcmktCheckDepositHowToTrade = () => instance.post(`${tradingTips}check/howToTradeDeposit`)
export const apiTcmktCheckTnc = () => instance.post(`${tcmktUrl}check/tnc`)
export const apiTcmktTncAccept = () => instance.post(`${tcmktUrl}tnc/accept`)
export const apiTcmktGetUrl = () => instance.post(`${tcmktUrl}getUrl`)
export const apiCheckAccStatus = () => instance.get(`${tradingTips}check/accountStatus`);

/** tcvideoUrl */
export const apiProCheckUnlocked = () => instance.get(`${tradingTips}/unlocked`)

/** demoUrl */
export const apiGet_demo_accs = () => instance.get(`${demoUrl}get_demo_accs`)

/** locationTrace */
//https://www.cloudflare.com/cdn-cgi/trace get location info by tracing cloudflare
export const apiGetUserLocation = () => instanceExternal.get(`${locationTrace}`)

/** google translation */
export const apiGetTranslation = data => instanceExternal.post(`${googleTranslateBasic}`, data)

/** notification */
export const apiGetNotifications = ({ country }) => instance.get(`${notificationUrl}enabled?country=${country}`)

/** banner */
// displayPlatform standadize with BE (BannerDisplayPlatformEnum) & Admin (displayPlatformEnum)
// displayPage standadize with BE (BannerDisplayPageEnum) & CP (popupBannerDisplayPageEnum)
export const apiGetBanners = ({ country, displayPage }) =>
  instance.get(`${bannerUrl}enabled?displayPlatform=1&country=${country}&displayPage=${displayPage}`)
export const apiSnoozeBanner = notificationIdList => instance.post(`${bannerUrl}snooze`, { notificationIdList })

/** Verification */
export const apiSecurityPassed = data =>
  instance.get(`/hgw/auth-api/api/sliderChecker/passed`, {
    params: data,
  })

/** systemUrl */
export const apiInformation = () => instance.get(`${systemUrl}information`)

/**promotion */
const campaignUrl = `${baseUrl}campaign/`
export const apiReferralExchangeRate = data => instance.get(`${baseUrl}exchange-rate?from=${data.from}&to=${data.to}`)
export const apiReferralList = () => instance.get(`${campaignUrl}refer-a-friend/v2/participants`)
export const apiReferralEligibility = () => instance.get(`${campaignUrl}refer-a-friend/v2/eligible`)
export const apiReferralInfo = () => instance.get(`${campaignUrl}refer-a-friend/v2/info`)
export const apiReferralSubmitRedeem = data => instance.post(`${campaignUrl}refer-a-friend/v2/redeem`, data)

export const apiCampaignInfo = (id, langUsed) =>
  instance.get(`${campaignUrl}participants?campaignId=${id}${langUsed ? `&languageCode=${langUsed}` : ''}`)
export const apiEligibleCampaigns = () => instance.get(`${campaignUrl}eligible-campaigns`)
export const apiParticipatedCampaigns = () => instance.get(`${campaignUrl}participated-campaigns`)
export const apiTncInfo = id => instance.get(`${campaignUrl}info?campaignId=${id}`)
export const apiCampaignOpt = (id, optIn) => instance.post(`${campaignUrl}opt-in?campaignId=${id}&optIn=${optIn}`)
export const apiCampaignReference = (id, pageNumber, pageSize) =>
  instance.get(`${campaignUrl}reference?campaignId=${id}&pageNumber=${pageNumber}&pageSize=${pageSize}`)

export const apiRedeemableAcc = id => instance.get(`${campaignUrl}redeemable-accounts?campaignId=${id}`)
export const apiSubmitRedeem = data => instance.post(`${campaignUrl}requestRedeem`, data)
export const apiReferralLink = id => instance.get(`${campaignUrl}campaign-code?campaignId=${id}`)
export const apiDailyNewsletter = () => instance.get(`${campaignUrl}daily-trading-newsletter/status`)

export const apiOptInAcc = body => instance.post(`${campaignUrl}opt-in-with-account`, body)
export const apiOptOutAcc = body => instance.post(`${campaignUrl}opt-out-with-account`, body)
export const apiOptInWithAccounts = data => instance.post(`${campaignUrl}opt-in-with-accounts`, data)
export const apiOptOutWithAccounts = data => instance.post(`${campaignUrl}opt-out-with-accounts`, data)
export const apiGetFgpHistory = data => instance.get(`${campaignUrl}fgp/history`, { params: data })
export const apiGetFgpMonthlyHistory = data => instance.get(`${campaignUrl}fgp/monthlyHistory`, { params: data })
export const apiRedeemableAccount = id => instance.get(`${campaignUrl}redeemable-accounts?campaignId=${id}`)
export const apiAccountInfo = ({ participantId, depositCampaignId }) =>
  instance.get(
    `${campaignUrl}redeposit-bonus/accountInfo?participantId=${participantId}&depositCampaignId=${depositCampaignId}`
  )
export const apiAccountLogs = ({ participantId }) =>
  instance.get(`${campaignUrl}redeposit-bonus/accountLogs?participantId=${participantId}`)
export const apiActivedAccounts = id => instance.get(`${campaignUrl}redeposit-bonus/activeAccounts?campaignId=${id}`)
export const apiCreditToBalance = body => instance.post(`${campaignUrl}redeposit-bonus/convert`, body)
export const apiPauseOrStartCampaign = data => instance.post(`${campaignUrl}paused-campaign`, data)
export const apiGetCampaignParticipants = id => instance.get(`${campaignUrl}participants?campaignId=${id}`)
export const apiRedeemLossRecovery = body => instance.post(`${campaignUrl}loss-recovery/redeem`, body)
export const apiCampaignRedeem = body => instance.post(`${campaignUrl}/lny/redeem`, body)

/* VPS */
export const apiVpsHistory = () => instance.get(`${cpUrl}vps/claim-history`)
export const apiGetVpsAccounts = () => instance.get(`${cpUrl}vps/get-accounts`)
export const apiVpsSubmit = data => instance.post(`${cpUrl}vps/submit-refund-application`, data)
export const apiVpsEligible = data => instance.post(`${cpUrl}vps/validate-refund-application`, data)
export const apiVpsGetSaveChange = () => instance.get(`${cpUrl}vps/agreeTnC`)
export const apiVpsSetSaveChange = () => instance.post(`${cpUrl}vps/agreeTnC?agree=true`)
export const apiVpsGetTncDocuments = () => instance.get(`${cpUrl}vps/get-tnc-documents`)

/** Social Trading */
export const apiCheckSocialTradingFollowerResult = data =>
  instance.post(`${socialTradingUrl}checkSocialTradingFollowerResult`, qs.stringify(data))

/**Loyalty Programmme */
const loyaltyUrl = `${cpUrl}loyalty/`
export const apiLoyaltyLandingInfo = byPassLoading => instance.get(`${loyaltyUrl}landing-info`, { byPassLoading })
export const apiLoyaltyOnboardingPopUp = state => instance.put(`${loyaltyUrl}toggle-onboarding-pop-up?state=${state}`)
export const apiLoyaltyCashRebateAvailableAccounts = () => instance.get(`${loyaltyUrl}cash-rebate-available-accounts`)
export const apiLoyaltyCashRebatePointSelection = () => instance.get(`${loyaltyUrl}cash-rebate-point-selection`)
export const apiLoyaltyCashRebateCalculateRedeemAmount = body =>
  instance.post(`${loyaltyUrl}cash-rebate-calculate-redeem-amount`, body)
export const apiLoyaltyCashRebateRedemption = body => instance.post(`${loyaltyUrl}cash-rebate-redemption`, body)
export const apiLoyaltyRewards = data => instance.get(`${loyaltyUrl}available-rewards`, { params: data })
export const apiLoyaltyVouchers = data => instance.get(`${loyaltyUrl}available-voucher`, { params: data })
export const apiLoyaltyActivities = () => instance.get(`${loyaltyUrl}activities`)
export const apiLoyaltyApplicableAccounts = category => instance.get(`${loyaltyUrl}${category}/applicable-accounts`)
export const apiLoyaltyApplicableTrades = (category, body) =>
  instance.get(`${loyaltyUrl}${category}/applicable-trades`, { params: body })
export const apiLoyaltyConvertVoucher = (category, body) =>
  instance.post(`${loyaltyUrl}${category}/convert-voucher`, body)
export const apiLoyaltyApplyVoucher = (category, body) => instance.post(`${loyaltyUrl}${category}/apply-voucher`, body)
export const apiGetDepositDiscountVoucher = body =>
  instance.get(`${loyaltyUrl}deposit-discount/available-voucher`, body)
export const apiGetRoughExchangeRate = body => instance.get(`${campaignUrl}/rough-exchange-rate`, body)
export const apiGetSpinWheelInfo = body => instance.get(`${loyaltyUrl}spin-wheel`, { params: body })
export const apiGetSpinWheelResult = (params, body) =>
  instance.post(`${loyaltyUrl}spin-wheel/spin?${qs.stringify(params)}`, body)
export const apiOpenLuckyPacket = id => instance.post(`${loyaltyUrl}/lucky-packet?campaignId=${id}`)
export const apiAvailableLuckyPacket = id =>
  instance.get(`${loyaltyUrl}lucky-packet/available-lucky-packet-count?campaignId=${id}`)
export const apiRedeemCashByVoucher = body => instance.post(`${loyaltyUrl}/activate`, body)

/**Loyalty giftShop */
const loyaltyGiftShopUrl = `${cpUrl}giftShop/`
export const apiLoyaltyGiftShopAvailableGifts = ({ language, categoryId }) =>
  instance.get(
    `${loyaltyGiftShopUrl}availableGifts?language=${language}${categoryId ? `&categoryId=${categoryId}` : ''}`
  )
export const apiLoyaltyGiftShopCategories = ({ language }) =>
  instance.get(`${loyaltyGiftShopUrl}categories?language=${language}`)
export const apiLoyaltyGiftShopRedeem = data => instance.post(`${loyaltyGiftShopUrl}redeem`, data)
export const apiLoyaltyGiftShopActivities = ({ language, categoryId }) =>
  instance.get(`${loyaltyGiftShopUrl}activities?language=${language}${categoryId ? `&categoryId=${categoryId}` : ''}`)

// Trading Reward
export const apiRewardHistory = data =>
  instance.get(
    `${campaignUrl}rewards?pageNumber=${data.pageNumber}&pageSize=${data.pageSize}&campaignId=${data.campaignId}&sortBy=${data.sortBy}&direction=${data.direction}`
  )

export const apiRewardHistoryLogs = data =>
  instance.get(`${campaignUrl}rewardDetails?rewardId=${data.rewardId}&campaignId=${data.campaignId}`)

// Trading Contest
export const apiTradingContestEligibility = () => instance.get(`${campaignUrl}eligible-trading-contests`)
export const apiGetTradingContestParticipantInfo = body =>
  instance.get(`${campaignUrl}trading-contest-info`, { params: body })
export const apiGetTradingContestUsers = body => instance.get(`${campaignUrl}tradingContest/users`, { params: body })
export const apiGetTradingContestCountryBoard = body =>
  instance.get(`${campaignUrl}tradingContest/countryBoard`, { params: body })
export const apiApplyTradingContestAccount = data =>
  instance.post(`${campaignUrl}tradingContest/applyAdditionalAccount`, qs.stringify(data))
export const apiTradingContestOpt = params =>
  instance.post(`${campaignUrl}tradingContest/opt-in?${qs.stringify(params)}`)
export const apiGetTradingContestSpinWheelPrize = body =>
  instance.get(`${campaignUrl}tradingContest/spin-wheel`, { params: body, byPassLoading: true })
export const apiGetTradingContestSpinWheelResult = data =>
  instance.post(`${campaignUrl}tradingContest/spin-wheel/spin`, data, {
    byPassLoading: true,
  })

/**ticket */
const ticketUrl = `${cpUrl}ticket/`
export const apiTicketRequest = () => instance.get(`${ticketUrl}requests`)
export const apiTicketComment = id => instance.get(`${ticketUrl}comments?ticketId=${id}`)
export const apiTicketCommentUpdate = data =>
  instance.post(`${ticketUrl}update-ticket`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
export const apiSubmitTicket = data =>
  instance.post(`${ticketUrl}submit-ticket`, data, { headers: { 'Content-Type': 'multipart/form-data' } })

//
// import Axios from 'axios'
const securityUrl = `${baseUrl}security/`
export const apiGetSecurity = () => instance.get(`${securityUrl}getSecuritys`)
export const apiGetCurrentSecurity = functionCode => instance.get(`${securityUrl}current/${functionCode}/rule`) // functionCode: 'updatePassword' / 'updateUserLogin'

/** guide */
export const apiHomeReadGuide = data => instance.get(`${homeUrl}readGuide`, data)
export const apiHomeDoneGuide = data => instance.post(`${homeUrl}readGuide`, data)

/**session */
export const apiGetSessionId = () => instance.get(`${baseUrl}tool/session-id`)

// abTesting
export const apiGetAbTestingEligible = abTemplateDisplayPage =>
  instance.get(`${abTestingUrl}eligible/${abTemplateDisplayPage}`)
export const apiSubmitAbTesting = data => instance.post(`${abTestingUrl}submit`, data)

//pcs i18n json file
export const apiGetPCSI18nJSON = lang => instance.get(`${baseUrl}file/i18n-url/${lang}`)
export const apiGetResponseServerData = url => instanceExternal.get(`${url}`)

/**sumsub */
const sumsubUrl = `${cpUrl}sumsub/`
export const apiGetSumsubAccessToken = campaignId => {
  let campaignIdUrl = typeof campaignId === 'number' && !isNaN(campaignId) ? `/1/${campaignId}` : ''
  return instance.get(`${sumsubUrl}access-token${campaignIdUrl}`)
}
export const apiGetSumsubStatus = campaignId => instance.get(`${sumsubUrl}status/1/${campaignId}`)

// sumsub id verify
export const apiGetVerificationToken = type => {
  let url = '/web-api/api/verification/sumsub/token'
  if (type !== undefined) {
    url += `?type=${type}`
  }
  return instance.get(url)
}
export const apiGetSumsubJump = params => {
  return instance.get('/web-api/api/verification/sumsub/jump', {
    params,
  })
}

export const apiGetId3Status = () => instance.get('/web-api/api/personalDetail/id3Status')

// 2fa绑定前置检测状态查询
export const apiVerifyStatus = () => instance.get(`${cpUrl}multiFactorAuth/verifyStatus`)
// 查询人脸认证次数
export const apiVerifyNum = () => instance.get(`${cpUrl}multiFactorAuth/verifyNum`)
